import React from 'react';
import { AlertTriangleIcon, ShieldIcon, TrendingUpIcon } from 'lucide-react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { GlassCard } from '../ui/GlassCard';
export function FoundationalPremise() {
  return <SectionWrapper hasDivider glowPosition="right" data-id="element-69">
      <div className="max-w-3xl mb-16" data-id="element-70">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-white mb-6" data-id="element-71">
          Why the Cognarchic State exists
        </h2>
        <p className="text-lg text-slate-400 leading-relaxed" data-id="element-72">
          The Cognarchic State begins with the claim that neither mass
          participation alone nor rigid top-down control is sufficient for a
          stable modern political order. In an age shaped by information
          warfare, social fragmentation, and institutional distrust, the central
          civic problem is not only power, but judgment. A healthy society must
          be able to identify, cultivate, and protect sound decision-making at
          scale.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-6" data-id="element-73">
        <GlassCard glowColor="amber" className="flex flex-col h-full" data-id="element-74">
          <div className="w-12 h-12 rounded-full bg-amber-500/10 flex items-center justify-center mb-6 border border-amber-500/20" data-id="element-75">
            <AlertTriangleIcon className="w-6 h-6 text-amber-400" data-id="element-76" />
          </div>
          <h3 className="text-xl font-semibold text-white mb-3" data-id="element-77">
            Civilizational Instability
          </h3>
          <p className="text-slate-400 leading-relaxed flex-1" data-id="element-78">
            Poor judgment, volatility, and institutional decay weaken long-term
            order. The current systems fail to filter for cognitive resilience.
          </p>
        </GlassCard>

        <GlassCard glowColor="cyan" className="flex flex-col h-full" data-id="element-79">
          <div className="w-12 h-12 rounded-full bg-cyan-500/10 flex items-center justify-center mb-6 border border-cyan-500/20" data-id="element-80">
            <ShieldIcon className="w-6 h-6 text-cyan-400" data-id="element-81" />
          </div>
          <h3 className="text-xl font-semibold text-white mb-3" data-id="element-82">
            Judgment as a Public Good
          </h3>
          <p className="text-slate-400 leading-relaxed flex-1" data-id="element-83">
            Sound reasoning and self-mastery must be cultivated and protected.
            They are not merely personal virtues, but structural necessities.
          </p>
        </GlassCard>

        <GlassCard glowColor="teal" className="flex flex-col h-full" data-id="element-84">
          <div className="w-12 h-12 rounded-full bg-teal-500/10 flex items-center justify-center mb-6 border border-teal-500/20" data-id="element-85">
            <TrendingUpIcon className="w-6 h-6 text-teal-400" data-id="element-86" />
          </div>
          <h3 className="text-xl font-semibold text-white mb-3" data-id="element-87">
            Development over Condemnation
          </h3>
          <p className="text-slate-400 leading-relaxed flex-1" data-id="element-88">
            Citizens are not fixed categories, but capable of improvement. The
            state's role is developmental, not merely punitive.
          </p>
        </GlassCard>
      </div>
    </SectionWrapper>;
}